import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Header from '../components/Header';
import WorkstationTab from '../components/WorkstationTab';
import '../components/Dashboard.css';

const parseArray = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    if (typeof field === 'string') {
        const trimmed = field.trim();
        if (trimmed.startsWith('{') && trimmed.endsWith('}'))
            return trimmed.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, '')).filter(s => s !== '');
        try { const p = JSON.parse(trimmed); if (Array.isArray(p)) return p; } catch {}
        return trimmed.split(',').map(s => s.trim()).filter(s => s !== '');
    }
    return [field];
};

const FormulariosPage = () => {
    const navigate = useNavigate();
    const municipioId   = localStorage.getItem('user_municipio_id');
    const municipioNome = localStorage.getItem('user_municipio_nome') || '';

    const [registros,  setRegistros]  = useState([]);
    const [allAgents,  setAllAgents]  = useState([]);
    const [isLoading,  setIsLoading]  = useState(true);
    const [pagination, setPagination] = useState({ page: 1, limit: 50, total: 0 });
    const [filters,    setFilters]    = useState({
        etiqueta: '', local: '', agente: '', atividade: '', data_atividade: '', data_exame: '', status: 'todos',
    });

    useEffect(() => {
        if (!municipioId) { navigate('/'); return; }
        supabase.from('agentes').select('id, nome').eq('municipio_id', municipioId).order('nome')
            .then(({ data }) => setAllAgents(data || []));
    }, [municipioId, navigate]);

    useEffect(() => {
        if (!municipioId) return;
        const fetchOcorrencias = async () => {
            setIsLoading(true);
            try {
                const { data_exame, ...filtersForBackend } = filters;
                let query = supabase.from('ocorrencias_view').select('*', { count: 'exact' })
                    .eq('municipio_id', municipioId).order('created_at', { ascending: false });

                if (filtersForBackend.etiqueta) query = query.ilike('codigo_etiqueta', `%${filtersForBackend.etiqueta}%`);
                if (filtersForBackend.local)    query = query.or(`endereco.ilike.%${filtersForBackend.local}%,nome_localidade.ilike.%${filtersForBackend.local}%,nome_localidade_view.ilike.%${filtersForBackend.local}%`);
                if (filtersForBackend.agente)   query = query.eq('nome_agente_view', filtersForBackend.agente);
                if (filtersForBackend.data_atividade) query = query.gte('data_atividade', filtersForBackend.data_atividade).lte('data_atividade', filtersForBackend.data_atividade);
                if (filtersForBackend.atividade) query = query.ilike('tipo_atividade', `%${filtersForBackend.atividade}%`);
                if (filtersForBackend.status === 'pendente_campo') query = query.eq('sincronizado', false);
                else if (filtersForBackend.status === 'sincronizado') query = query.eq('sincronizado', true);
                else if (filtersForBackend.status === 'pendente_exame') query = query.is('exame_id', null);
                else if (filtersForBackend.status === 'positivo') query = query.eq('status_exame', 'Positivo');
                else if (filtersForBackend.status === 'negativo') query = query.eq('status_exame', 'Negativo');

                const from = (pagination.page - 1) * pagination.limit;
                query = query.range(from, from + pagination.limit - 1);

                const { data, error, count } = await query;
                if (error) throw error;
                const formatados = (data || []).map(item => ({
                    ...item,
                    data: item.data_atividade,
                    localidade: item.nome_localidade_view || item.nome_localidade || item.endereco || 'Não Informada',
                    categoria_localidade: item.categoria_localidade_view,
                    agente_nome: item.nome_agente_view || 'Agente Desconhecido',
                    status_sincronizacao: item.sincronizado ? 'Enviado' : 'Pendente',
                    tipo_atividade: parseArray(item.tipo_atividade),
                    fotos_urls: parseArray(item.fotos_urls),
                    barbeiros_intradomicilio: Number(item.barbeiros_intradomicilio) || 0,
                    barbeiros_peridomicilio:  Number(item.barbeiros_peridomicilio)  || 0,
                    quantidade_moradores:     Number(item.quantidade_moradores)     || 0,
                    vestigios_intra: item.vestigios_intradomicilio,
                    vestigios_peri:  item.vestigios_peridomicilio,
                    ocorrencia_data_registro: item.created_at,
                }));
                setRegistros(formatados);
                setPagination(prev => ({ ...prev, total: count || 0 }));
            } catch (err) {
                console.error('Erro ao buscar ocorrências (formulários):', err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchOcorrencias();
    }, [filters, pagination.page, pagination.limit, municipioId]);

    const fetchAllRegistros = useCallback(async () => {
        if (!municipioId) return [];
        try {
            const { data_exame, ...filtersForBackend } = filters;
            let query = supabase.from('ocorrencias_view').select('*').eq('municipio_id', municipioId).order('created_at', { ascending: false });
            if (filtersForBackend.etiqueta) query = query.ilike('codigo_etiqueta', `%${filtersForBackend.etiqueta}%`);
            if (filtersForBackend.local)    query = query.or(`endereco.ilike.%${filtersForBackend.local}%,nome_localidade.ilike.%${filtersForBackend.local}%,nome_localidade_view.ilike.%${filtersForBackend.local}%`);
            if (filtersForBackend.agente)   query = query.eq('nome_agente_view', filtersForBackend.agente);
            if (filtersForBackend.data_atividade) query = query.gte('data_atividade', filtersForBackend.data_atividade).lte('data_atividade', filtersForBackend.data_atividade);
            if (filtersForBackend.atividade) query = query.ilike('tipo_atividade', `%${filtersForBackend.atividade}%`);
            if (filtersForBackend.status === 'pendente_campo') query = query.eq('sincronizado', false);
            else if (filtersForBackend.status === 'sincronizado') query = query.eq('sincronizado', true);
            else if (filtersForBackend.status === 'pendente_exame') query = query.is('exame_id', null);
            else if (filtersForBackend.status === 'positivo') query = query.eq('status_exame', 'Positivo');
            else if (filtersForBackend.status === 'negativo') query = query.eq('status_exame', 'Negativo');
            const { data, error } = await query;
            if (error) throw error;
            return (data || []).map(item => ({
                ...item,
                data: item.data_atividade,
                localidade: item.nome_localidade_view || item.nome_localidade || item.endereco || 'Não Informada',
                agente_nome: item.nome_agente_view || '',
                tipo_atividade: parseArray(item.tipo_atividade),
                fotos_urls: parseArray(item.fotos_urls),
                barbeiros_intradomicilio: Number(item.barbeiros_intradomicilio) || 0,
                barbeiros_peridomicilio:  Number(item.barbeiros_peridomicilio)  || 0,
            }));
        } catch (err) {
            console.error('Erro ao buscar todos os registros (formulários):', err);
            return [];
        }
    }, [filters, municipioId]);

    const handleFilterChange = useCallback((newFilters) => {
        setPagination(prev => ({ ...prev, page: 1 }));
        setFilters(prev => ({ ...prev, ...newFilters }));
    }, []);

    const handlePageChange = useCallback((newPage) => {
        setPagination(prev => ({ ...prev, page: newPage }));
    }, []);

    if (!municipioId) return null;

    return (
        <div className="portal-layout">
            <Header activeView="vigilanciaEntomologica" />
            <main className="main-content">
                {isLoading && registros.length === 0 ? (
                    <div className="content-container">
                        <div className="loading-screen"><div className="spinner" /><p>Sincronizando dados...</p></div>
                    </div>
                ) : (
                    <div className="content-container">
                        <div className="tab-header-container">
                            <div className="tab-title-group">
                                <h1 className="tab-title-main">Formulários de Campo</h1>
                                <p className="tab-subtitle-main">Pesquise por <strong>Data, Etiqueta, Agente ou Localidade</strong>.</p>
                            </div>
                            <a href="/ficha-campo" className="btn-register-action">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                Registrar Formulário de Campo
                            </a>
                        </div>
                        <div className="info-text-box">
                            <strong>Sincronização com Sistemas Oficiais:</strong>{' '}
                            Nosso sistema não sincroniza automaticamente os formulários de campo com os sistemas oficiais de registro. Por isso, todos os novos registros são salvos inicialmente com o status <strong>PENDENTE</strong>.
                            Ao clicar em <em>Processar</em> na coluna de status, você será redirecionado para a tela de "Processar Formulário de Campo", onde o responsável pela digitação visualiza todas as informações técnicas para transferi-las manualmente ao sistema oficial.
                            Após finalizar a inserção, clique em <em>Concluir e Sincronizar</em> — a ficha passará a ter o status <strong>SINCRONIZADO</strong>, indicando que o trabalho foi devidamente processado.
                        </div>
                        <WorkstationTab
                            registros={registros}
                            serverPage={pagination.page}
                            serverTotal={pagination.total}
                            serverFilters={filters}
                            allAgentsList={allAgents}
                            municipioNome={municipioNome}
                            onPageChange={handlePageChange}
                            onFilterChange={handleFilterChange}
                            onFetchAll={fetchAllRegistros}
                        />
                    </div>
                )}
            </main>
        </div>
    );
};

export default FormulariosPage;
